export enum MyScheduleAgendaTypeFilterOptions {
  APPOINTMENT = 'APPOINTMENT,PERSONAL_TIME',
  SESSION = 'SESSION'
}
export const SEARCH_SCHEDULE_LIMIT = Object.freeze({
  UPCOMING: 20,
  AGENDA_LIST: 20
});
